<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Class Name</label>
             <CRow >
              <CCol >
              <b-input
                v-model="form.name"
                placeholder="Class Name"
                id="feedback-user"
                class="mb-1"
                :class="errors.name ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback >
                Your Class name must be filled
              </b-form-invalid-feedback>    
              </CCol>
            </CRow>
             <CRow >
              <CCol >
                <label > Class Classification</label>
                 <b-form-select
                v-model="form.ikid_class_id"
                :options= "options"
                id="feedback-user"
                :class="errors.ikid_class_id ? 'is-invalid' : ''"
               >
              </b-form-select>
              <b-form-invalid-feedback >
              Your Class Classification must be selected
              </b-form-invalid-feedback>
              </CCol>
            </CRow>            
          </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Edit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import class_classification from '@/services/classclassification'
import class_kid from '@/services/class'

export default {
name: 'classmodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      errors: {},
      errors_from_backend: [],
      options: [],
      form:{
        id: '',
        name: '',
        ikid_class_id: ''
      },
      loading: false,
    }
  },
   computed: {
      validationName() {
        return this.form.name.length > 0 
      },
   },
  mounted(){
    
  },
  created () {
    var self = this;
    this.getClass()

    EventBus.$on('OPEN_MODAL_CLASS_CLASSIFICATION', (params) => {
      if(params.data){
        class_classification.getClassClassificationbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.name = res.data.name;
          self.form.ikid_class_id = res.data.ikid_class_id
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
        self.form.ikid_class_id = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.loading = true;
      if (this.check_form()) {
      class_classification.createClassClassification(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch((err) => {
        this.loading = false;
        alert(err.response.data.message);
        //alert(JSON.stringify(err.response.data.errors));
        if (err.response.data.errors != null) {
            this.errors_from_backend = err.response.data.errors;
            console.log(JSON.stringify(err.response.data.errors));
        }
        });
      } else {
        this.loading = false;
      }
    },
    update(id){
      this.show = false;
      class_classification.updateClassClassification(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    getClass(){
      this.options = []
      class_kid.getClass()
      .then(res => {
        for(let i = 0; i <= res.data.length-1; i++){
          this.options.push({text: res.data[i].name, value: res.data[i].id});
        }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })   
    },
    check_form: function(e) {
         this.errors = {};
         if (!this.form.name) {
            this.errors["name"] = "1";
         }
        if (!this.form.ikid_class_id) {
            this.errors["ikid_class_id"] = "1";
         }

        if (
            this.form.name &&
            this.form.ikid_class_id 
         ){
            return true;
         } else {
            return false;
         }
      },
  }
}
</script>
